import React from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import AppLayout from "layouts/app-layout";
import AuthLayout from 'layouts/auth-layout';
import PoolLayout from "layouts/pool-layout";
import SystemLayout from "layouts/system-layout";
import AppLocale from "lang";
import { IntlProvider } from "react-intl";
import { ConfigProvider } from 'antd';
import { POOL_PREFIX_PATH, APP_PREFIX_PATH, AUTH_PREFIX_PATH, SYSTEM_PREFIX_PATH, CONFIG_PREFIX_PATH, UTILITIES_PREFIX_PATH, PERMISSIONS_PREFIX_PATH} from 'configs/AppConfig'
import samacLib from '../lib/samac'
import useBodyClass from 'hooks/useBodyClass';
import Utils from '../utils/index'
import 'moment/locale/it';

function RouteInterceptor({ children, isAuthenticated, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: AUTH_PREFIX_PATH,
              state: { from: location }
            }}
          />
        )
      }
    />
  );
}

export const Views = (props) => {
  const { locale, token, location, direction } = props;
  const currentAppLocale = AppLocale[locale];

  samacLib.setCurrentAppLocale(currentAppLocale);

  useBodyClass(`dir-${direction}`);
  return (
    <IntlProvider
      locale={currentAppLocale.locale}
      messages={currentAppLocale.messages}>
      <ConfigProvider locale={currentAppLocale.antd} direction={direction}>
        <Switch>
          <Route path={AUTH_PREFIX_PATH}>
            <AuthLayout direction={direction} />
          </Route>
          <Route path={POOL_PREFIX_PATH}>
            <PoolLayout direction={direction} />
          </Route>
          {(token !== '' && token !== null) && Utils.UserIsAdmin() && (
          <RouteInterceptor path={SYSTEM_PREFIX_PATH} isAuthenticated={token !== '' && token !== null}>
            <SystemLayout direction={direction} location={location}/>
          </RouteInterceptor>)}
          {(token !== '' && token !== null) && Utils.UserIsAdmin() && (
          <RouteInterceptor path={CONFIG_PREFIX_PATH} isAuthenticated={token !== '' && token !== null}>
            <SystemLayout direction={direction} location={location}/>
          </RouteInterceptor>)}
          {(token !== '' && token !== null) && (Utils.UserIsAdmin() || Utils.GetCurrentUser() === 'IMP000109' || Utils.canShowNav("utilities")) && (
          <RouteInterceptor path={UTILITIES_PREFIX_PATH} isAuthenticated={token !== '' && token !== null}>
            <SystemLayout direction={direction} location={location}/>
          </RouteInterceptor>)}
          {(token !== '' && token !== null) && (Utils.UserIsAdmin()) && (
          <RouteInterceptor path={PERMISSIONS_PREFIX_PATH} isAuthenticated={token !== '' && token !== null}>
            <SystemLayout direction={direction} location={location}/>
          </RouteInterceptor>)}
          {(token !== '' && token !== null) && Utils.canAccessPath(location?.pathname) && (
          <RouteInterceptor path={APP_PREFIX_PATH} isAuthenticated={token !== '' && token !== null}>
            <AppLayout direction={direction} location={location}/>
          </RouteInterceptor>)}
          
          {(token === '' || token === null) && 
            <Route path=''>
              <Redirect to="/auth/login" />
            </Route>}
          <Redirect to="/pool/404" />
        </Switch>
      </ConfigProvider>
    </IntlProvider>
  )
}

const mapStateToProps = ({ theme, auth }) => {
  const { locale, direction } =  theme;
  const { token } = auth;
  return { locale, token, direction }
};

export default withRouter(connect(mapStateToProps)(Views));